/* Selv Rituel · fenêtre de bienvenue (sections/selv-bienvenue.liquid), 26 oct. 2026 ; plan 05 § 6.3, revue 06, passe 2.
   Mémoire « selv-bv » {v, refus, t, inscrite} ; stockage bloqué : aucune ouverture automatique.
   Une seule ouverture automatique par page ; après une fermeture, plus rien ne la rouvre (sauf éditeur et ?bienvenue=). */
(() => {
  'use strict';
  if (window.SelvBienvenue) return window.SelvBienvenue.scan();
  const d = document, h = d.documentElement, K = 'selv-bv', ctl = new Map();
  let picked = '';
  const ls = () => { try { localStorage.setItem(K + '-t', '1'); localStorage.removeItem(K + '-t'); return JSON.parse(localStorage.getItem(K) || '{}') || {}; } catch (e) { return null; } };
  const save = (o) => { try { localStorage.setItem(K, JSON.stringify(Object.assign({ v: 1, refus: 0 }, ls(), o))); } catch (e) { /* bloqué */ } };
  const ss = (k, v) => { try { return v === undefined ? sessionStorage.getItem(k) : sessionStorage.setItem(k, v); } catch (e) { return null; } };
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));
  // Même seuil qu'en CSS (max-width:749.98px)
  const MQ = matchMedia('(min-width: 750px)');
  const desk = () => MQ.matches;
  const FIELD = 'input:not([type=checkbox]):not([type=radio]):not([type=button]):not([type=submit]),textarea,select,[contenteditable]';

  // Voie libre : ni témoins, tiroir, autre calque, clavardage ouvert ni saisie en cours.
  // layers : calques seulement (feuille déjà ouverte : onglet masqué et saisie ne comptent pas).
  const busy = (dlg, layers) => {
    const b = d.getElementById('shopify-pc__banner'), r = b && !b.hidden && b.getBoundingClientRect();
    const cd = d.getElementById('CartDrawer'), a = d.activeElement;
    return (!layers && d.visibilityState === 'hidden')
      || !!(r && r.width && r.height && getComputedStyle(b).visibility !== 'hidden')
      || /\b(js-drawer-open|theme-modal-open)/.test(d.body.className)
      || /\b(sq-lock|sf-zoom-open|atl-veil-on)\b/.test(h.className)
      || !!(cd && cd.getAttribute('aria-hidden') === 'false')
      || !!d.querySelector('shopify-chat[open]')
      || [...d.querySelectorAll('dialog[open]')].some((x) => x !== dlg)
      || (!layers && !!(a && a.matches && !dlg.contains(a) && a.matches(FIELD)));
  };

  function init(dlg) {
    let cfg;
    try { cfg = JSON.parse(dlg.querySelector('[data-bv-config]').textContent); } catch (e) { return; }
    const id = cfg.id, T = cfg.t || {};
    if (ctl.has(id)) ctl.get(id)();
    const ac = new AbortController(), timers = [];
    const on = (t, e, f, o) => t.addEventListener(e, f, Object.assign({ signal: ac.signal }, o));
    const later = (f, ms) => timers.push(setTimeout(f, ms));
    const q = (s) => dlg.querySelector(s);
    const form = q('form'), email = q('[data-bv-email]'), err = q('[data-bv-err]'), live = q('[data-bv-live]'), vv = window.visualViewport;
    const submit = form.querySelector('[type=submit]');
    const P = new URLSearchParams(location.search), test = P.get('bienvenue'), quiet = cfg.design || !!test;
    let prev = null, sheet = false, shown = false, stopped = false, waiting = null, veil = false, layerMo = null, retries = 0;

    d.body.appendChild(dlg); // hors du pied de page (contexte d'empilement)
    form.noValidate = true;

    const say = (el, msg) => { el.textContent = ''; setTimeout(() => { el.textContent = msg || ''; }, 60); };
    const done = () => /^(success|neutral)$/.test(dlg.dataset.state);
    const title = () => q(done() ? `#SelvBvT${dlg.dataset.state === 'success' ? 's' : 'n'}-${id}` : `#SelvBvT-${id}`);
    const showErr = (msg, focus) => { say(err, msg); email.setAttribute('aria-invalid', 'true'); if (focus) email.focus(); };
    const state = (st) => {
      dlg.dataset.state = st;
      dlg.setAttribute('aria-labelledby', title().id);
      if (done()) dlg.removeAttribute('aria-describedby'); else dlg.setAttribute('aria-describedby', `SelvBvD-${id}`);
      // Erreur au retour d'envoi : message posé avant l'affichage (aucun décalage), puis annoncé normalement
      if (st === 'error') { if (dlg.open) showErr(T.general); else { err.textContent = T.general; email.setAttribute('aria-invalid', 'true'); } }
    };
    // Feuille : levée au-dessus du clavier seulement si le focus est dedans ; sinon masquée tant que le
    // clavier sert un champ de la page (WCAG 2.4.11). scroll-padding pour le champ actif de la page.
    const fit = () => {
      if (!sheet || !dlg.open) return;
      const inS = dlg.contains(d.activeElement);
      const kb = vv && Math.abs((vv.scale || 1) - 1) < 0.01 ? Math.max(0, Math.round(innerHeight - vv.height - vv.offsetTop)) : 0;
      const hide = kb > 0 && !inS;
      dlg.inert = hide;
      dlg.style.visibility = hide ? 'hidden' : '';
      dlg.style.setProperty('--bv-kb', (inS ? kb : 0) + 'px');
      if (vv) dlg.style.setProperty('--bv-vv', vv.height + 'px');
      h.style.scrollPaddingBottom = hide ? '' : dlg.offsetHeight + (inS ? kb : 0) + 'px';
    };
    // Feuille ouverte (non modale) : un calque qui s'ouvre ensuite (tiroir, ajout rapide, menu) la ferme, sans refus
    const watch = () => {
      let raf = 0;
      const check = () => { raf = 0; if (dlg.open && sheet && busy(dlg, true)) { close('silent'); stopped = true; } };
      layerMo = new MutationObserver(() => { if (!raf) raf = requestAnimationFrame(check); });
      [h, d.body].forEach((n) => layerMo.observe(n, { attributes: true, attributeFilter: ['class'] }));
      const cd = d.getElementById('CartDrawer');
      if (cd) layerMo.observe(cd, { attributes: true, attributeFilter: ['aria-hidden'] });
    };

    async function open(st, again) {
      if (stopped) return;
      st = st || 'form';
      state(st);
      if (dlg.open) return;
      const l = d.querySelector('link[data-bv-css]'), tpl = q('template[data-bv-img]');
      // Feuille différée (media=print, puis all au chargement) : l'attendre et l'appliquer avant de mesurer les polices
      if (l && l.media !== 'all') {
        if (!l.sheet) await Promise.race([new Promise((r) => l.addEventListener('load', r, { once: true })), wait(3000)]);
        l.media = 'all';
      }
      sheet = !desk() && cfg.mobile !== 'card';
      // Polices du titre, de son italique, du texte et des boutons chargées avant l'affichage : aucun saut de ligne
      // pendant l'ouverture (CLS 0). Attente bornée.
      if (d.fonts && d.fonts.load) {
        const fl = [...dlg.querySelectorAll('.selv-bv__h,.selv-bv__h em,.selv-bv__lead,.selv-bv__btn')].map((el) => {
          const c = getComputedStyle(el);
          return d.fonts.load(`${c.fontStyle} ${c.fontWeight} 16px ${c.fontFamily}`, el.textContent.trim().slice(0, 60) || 'a').catch(() => {});
        });
        await Promise.race([Promise.all(fl), wait(1500)]);
      }
      // Photo : dans un <template> (rien de téléchargé ni d'indexé avant l'ouverture). Insérée pour la carte mobile et
      // le bureau assez haut (masquée en CSS sous 541 px de haut), jamais pour la feuille.
      if (tpl && !sheet && (!desk() || matchMedia('(min-height: 541px)').matches)) {
        tpl.replaceWith(tpl.content.cloneNode(true));
        const img = q('.selv-bv__img');
        if (img) await Promise.race([img.decode ? img.decode().catch(() => {}) : 0, wait(800)]);
      }
      if (stopped || dlg.open) return;
      // La voie a pu se fermer pendant l'attente (tiroir, menu, saisie) : attendre de nouveau
      if (st === 'form' && !quiet && !again && busy(dlg) && retries++ < 3) { whenClear(); return; }
      if (!again) prev = d.activeElement;
      if (sheet) dlg.show(); else { dlg.showModal(); h.classList.add('selv-bv-lock'); }
      shown = true;
      h.classList.add('selv-bv-on');
      if (sheet) watch();
      fit();
      // Bureau : champ courriel ; mobile : titre (sans faire surgir le clavier)
      const f = !done() && (dlg.dataset.state === 'error' || desk()) ? email : title();
      f.focus({ preventScroll: true });
      if (!quiet) ss(K + '-vu', '1');
    }

    const cleanup = () => {
      h.classList.remove('selv-bv-on', 'selv-bv-lock');
      h.style.scrollPaddingBottom = '';
      dlg.style.removeProperty('--bv-kb');
      dlg.style.removeProperty('--bv-vv');
      dlg.style.visibility = '';
      dlg.inert = false;
      if (layerMo) { layerMo.disconnect(); layerMo = null; }
      sheet = false;
    };
    const close = (w) => { if (dlg.open) { dlg.close(); after(w); } };

    // Bilan de fermeture, une seule fois (bouton, Échap, voile, éditeur) ; avant l'inscription, c'est un refus
    function after(w) {
      if (!shown) return;
      shown = false;
      const st = dlg.dataset.state;
      cleanup();
      if (w === 'silent') return;
      // Plus aucune ouverture automatique sur cette page (intention de sortie, minuterie)
      if (!quiet) { stopped = true; if (waiting) waiting(); }
      if (!quiet && !done()) { const m = ls() || {}; save({ refus: (m.refus || 0) + 1, t: Date.now() }); }
      if (prev && prev.isConnected && prev !== d.body) prev.focus({ preventScroll: true });
      d.dispatchEvent(new CustomEvent('selv:bienvenue:close', { detail: { state: st, reason: w } }));
    }
    on(dlg, 'close', () => { if (!dlg.open) after('esc'); }); // fermée par le navigateur (Échap)
    on(d, 'keydown', (e) => { if (e.key === 'Escape' && sheet && (dlg.contains(d.activeElement) || d.activeElement === d.body)) close('esc'); });
    on(dlg, 'pointerdown', (e) => { veil = e.target === dlg; });
    on(dlg, 'click', (e) => {
      const t = e.target, c = t.closest('[data-bv-close]'), a = t.closest('[data-bv-apply]');
      if (t === dlg && veil && !sheet) close('voile');
      else if (c) close(c.dataset.bvClose);
      else if (t.closest('[data-bv-copy]')) copy();
      else if (a) apply(e, a);
    });
    on(email, 'input', () => { err.textContent = ''; email.removeAttribute('aria-invalid'); });
    if (vv) { on(vv, 'resize', fit); on(vv, 'scroll', fit); }
    on(d, 'focusin', fit);
    on(d, 'focusout', () => setTimeout(fit, 0));
    // Rotation, fenêtre redimensionnée ou zoom qui franchit 750 px : rouvrir dans le bon format, sans refus
    on(MQ, 'change', () => { if (!dlg.open) return; const st = dlg.dataset.state; close('silent'); open(st, true); });

    async function copy() {
      let ok = false;
      try { await navigator.clipboard.writeText(cfg.code); ok = true; } catch (e) {
        const r = d.createRange(), s = getSelection();
        r.selectNodeContents(q('[data-bv-code]')); s.removeAllRanges(); s.addRange(r);
        try { ok = d.execCommand('copy'); } catch (x) { /* le code reste sélectionné */ }
      }
      say(live, ok ? T.copied : T.copyFail);
    }

    // Appliquer : par window.SelvCart (cart/update.js, tiroir rendu) sans son annonce « Code … appliqué »,
    // fausse pour une invitée ; sans SelvCart ou en cas d'échec, le lien /discount/ prend le relais.
    async function apply(e, a) {
      const SC = window.SelvCart;
      if (!SC || typeof SC.post !== 'function') return;
      e.preventDefault();
      e.stopPropagation(); // avant l'écouteur [data-selv-apply-code] de selv-cart.js (document)
      if (a.getAttribute('aria-busy') === 'true') return;
      a.setAttribute('aria-busy', 'true');
      try {
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const c = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
        const codes = (c.discount_codes || []).map((x) => x.code).filter((x) => x && x.toUpperCase() !== cfg.code.toUpperCase());
        codes.push(cfg.code);
        const r = await SC.post('cart/update.js', { discount: codes.join(','), sections: typeof SC.sections === 'function' ? SC.sections() : 'cart-drawer' });
        if (typeof SC.apply === 'function') SC.apply(r);
        a.removeAttribute('aria-busy');
        say(live, T.applied);
      } catch (x) { location.href = a.href; }
    }

    // Validation avant hCaptcha (capture sur le document). Pas de blocage d'un 2e envoi : le script hCaptcha
    // de Shopify peut renvoyer lui-même le formulaire.
    on(d, 'submit', (e) => {
      if (e.target !== form) return;
      const v = email.value.trim();
      const bad = !v ? T.empty : !email.checkValidity() || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v) ? T.format : '';
      if (bad || cfg.design) { e.preventDefault(); e.stopImmediatePropagation(); }
      if (bad) showErr(bad, true);
      else if (cfg.design) state('success');
      else { submit.setAttribute('aria-busy', 'true'); later(() => submit.removeAttribute('aria-busy'), 10000); }
    }, { capture: true });
    // Retour par Précédent (cache de page) : bouton rendu
    on(window, 'pageshow', () => submit.removeAttribute('aria-busy'));

    const hook = () => {
      const b = window.eventBus;
      if (hook.ok || !b || typeof b.on !== 'function') return;
      hook.ok = true;
      // Un ajout au panier annule la fenêtre pour la page ; la feuille ouverte se ferme (le tiroir passe devant)
      b.on('cart:added', () => {
        if (ac.signal.aborted) return;
        stopped = true;
        if (waiting) waiting();
        if (dlg.open && sheet) close('silent');
      });
    };

    // Ouvre quand la voie est libre depuis 1 s ; abandon après 60 s
    function whenClear() {
      if (stopped || dlg.open || waiting || (!quiet && ss(K + '-vu'))) return;
      let since = 0, raf = 0;
      const t0 = Date.now(), iv = setInterval(() => tick(), 500);
      const mo = new MutationObserver(() => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; tick(); }); });
      waiting = () => { clearInterval(iv); mo.disconnect(); cancelAnimationFrame(raf); waiting = null; };
      const tick = () => {
        if (!waiting) return;
        if (busy(dlg)) since = 0; else since = since || Date.now();
        if (stopped || Date.now() - t0 > 6e4) waiting();
        else if (since && Date.now() - since >= 1000) { waiting(); open('form'); }
      };
      [h, d.body].forEach((n) => mo.observe(n, { attributes: true, attributeFilter: ['class'] }));
      tick();
    }

    function arm() {
      const n = (parseInt(ss(K + '-pages'), 10) || 0) + 1, m = ls(), refus = (m && m.refus) || 0;
      ss(K + '-pages', String(n));
      // Retour d'un autre formulaire client (pied de page) : jamais d'ouverture ; abonnée si l'envoi a réussi
      if (P.has('customer_posted') || q('[data-bv-posted]')) { if (q('[data-bv-posted="ok"]')) save({ inscrite: true }); return; }
      if (!m || m.inscrite || refus >= cfg.maxDeclines || (refus && Date.now() - (m.t || 0) < cfg.days * 864e5)) return;
      if (cfg.cart || /(?:^|;\s*)discount_code=/.test(d.cookie) || P.get('utm_medium') === 'email' || P.has('_kx')) return;
      if ((!cfg.showMobile && !desk()) || ss(K + '-vu')) return;
      if (cfg.trigger === 'pages' && n >= cfg.pages) { later(whenClear, cfg.pageDelay * 1000); return; }
      // Engagement : délai ET défilement ; au bureau, intention de sortie
      let tOk = false, sOk = false;
      const go = () => { if (tOk && sOk) whenClear(); };
      const sc = new AbortController();
      ac.signal.addEventListener('abort', () => sc.abort());
      const scroll = () => {
        if (sOk) return;
        const max = h.scrollHeight - innerHeight;
        if (max <= 0 || (scrollY / max) * 100 >= cfg.engageScroll) { sOk = true; sc.abort(); go(); }
      };
      later(() => { tOk = true; go(); }, cfg.engageS * 1000);
      window.addEventListener('scroll', scroll, { passive: true, signal: sc.signal });
      scroll();
      if (cfg.exit && matchMedia('(hover: hover) and (pointer: fine)').matches) {
        on(d, 'mouseout', (e) => { if (!e.relatedTarget && e.clientY <= 0) whenClear(); });
      }
    }

    function start() {
      hook();
      if (cfg.design) { if (cfg.testMode || picked === id) open(cfg.editorState); return; }
      // Retour d'envoi ; neutre = courriel déjà connu (ni succès ni erreur)
      if (location.hash === '#selv-bienvenue-form') {
        const st = q('[data-bv-posted="ok"]') ? 'success' : q('[data-bv-posted="error"]') ? 'error' : 'neutral';
        if (st !== 'error') save({ inscrite: true });
        P.delete('customer_posted');
        history.replaceState(history.state, '', location.pathname + (P.toString() ? '?' + P : ''));
        open(st);
        return;
      }
      const forced = { test: 'form', succes: 'success', neutre: 'neutral', erreur: 'error' }[test];
      if (forced) later(() => open(forced), 600); else arm();
    }

    if (cfg.design) {
      on(d, 'shopify:section:select', (e) => { if (e.detail.sectionId === id) open(cfg.editorState); });
      on(d, 'shopify:section:deselect', (e) => { if (e.detail.sectionId === id) close('silent'); });
    }
    // Retour d'envoi et éditeur : tout de suite (script en defer, DOM prêt) ; sinon après le chargement
    if (location.hash === '#selv-bienvenue-form' || cfg.design || d.readyState === 'complete') start();
    else on(window, 'load', start, { once: true });
    ctl.set(id, () => {
      stopped = true;
      if (waiting) waiting();
      timers.forEach(clearTimeout);
      close('silent');
      cleanup();
      ac.abort();
      dlg.remove();
      ctl.delete(id);
    });
  }

  const scan = (root) => (root || d).querySelectorAll('dialog[data-selv-bv]:not([data-bv-init])').forEach((x) => { x.dataset.bvInit = '1'; init(x); });
  window.SelvBienvenue = { scan };
  // Éditeur : sélection gardée d'un rechargement à l'autre
  d.addEventListener('shopify:section:select', (e) => { picked = e.detail.sectionId; });
  d.addEventListener('shopify:section:deselect', () => { picked = ''; });
  d.addEventListener('shopify:section:load', (e) => scan(e.target));
  d.addEventListener('shopify:section:unload', (e) => { const x = ctl.get(e.detail.sectionId); if (x) x(); });
  scan();
})();
